export default __webpack_public_path__ + "static/media/negativo.7753dea3.png";